<template>
  <div>
    <add-cash-in-method :is-active.sync="isAdding" @changed="cashInMethodAdded" />
    <data-table
      title="CashIn Methods"
      :url="url"
      :headers="headers"
      :fields="fields"
      ref="table"
      searchable
      @click:row="showDetails"
      @rowClicked="showDetails"
    >
      <template slot="action.icons">
        <v-btn color="primary" @click="isAdding = true">
          <v-icon color="light-blue lighten-4">
            mdi-plus-outline
          </v-icon>
          Add CashIn Method
        </v-btn>
      </template>
    </data-table>
  </div>
</template>

<script>
import AddCashInMethod from "./form";

export default {
  props: {
    payment_provider_id: { type: [String, Number], default: "" },
  },
  components: { AddCashInMethod },
  data() {
    return {
      isAdding: false,
      url: `/api/v1/transactions/cryptoCashInMethods?payment_provider_id=${this.payment_provider_id}`,
      headers: {
        name: "Name",
        type: "Type",
        "payment_provider.name": "Provider",
        min_amount: "Min Amount",
        max_amount: "Max Amount",
      },
      fields: {
        min_amount: {
          format: (value) => {
            return `€ ${this.asCurrency(value)}`;
          },
        },
        max_amount: {
          format: (value) => {
            return `€ ${this.asCurrency(value)}`;
          },
        },
      },
    };
  },
  watch: {
    url() {
      this.$nextTick(() => {
        this.$refs.table.fetchData();
      });
    },
  },
  methods: {
    cashInMethodAdded({ message }) {
      this.isAdding = false;
      Notify.success(message);
      // refresh the table data
      this.$refs.table.fetchData();
    },
    showDetails({ id }) {
      this.$router.push({ name: "crypto.cashInMethods.show", params: { id } });
    },
  },
};
</script>
